import { render } from "./TiyoTable.vue?vue&type=template&id=2ca342c5"
import script from "./TiyoTable.vue?vue&type=script&lang=js"
export * from "./TiyoTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__